<script lang="ts">
	import type { Company } from "@core/schema/Company.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";

	const { companies }: { companies: Company[] } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<section class="grid-container full-width bg-gradient-to-t from-light/50 to-light lg:pt-20 pb-10 pt-12 lg:pb-16">
	<h2 class="text-center max-w-xl mx-auto mb-6 max-lg:text-xl">
		<Formatted text="clb[[Spolupracujeme]] s renomovanými výrobci" />
	</h2>
	<p class="max-w-xl text-center mx-auto leading-relaxed lg:leading-6">
		<Formatted
			text="Ve spolupráci s firmou EuroClone, Leica Biosystems a CytoTest pořádáme workshopy a školení. V oblasti cytogenetiky a molekulární biologie poskytujeme odbornou podporu při zpracování a kultivaci biologického materiálu.Specializujeme se také na metodu fluorescenční in situ hybridizace (FISH), která umožňuje přesnou detekci a analýzu genetických změn. Naším cílem je nabídnout spolehlivé řešení a kvalitní výsledky pro výzkum i diagnostickou praxi."
		/>
	</p>
	<div class="max-lg:full-width">
		<div
			class="md:flex grid grid-cols-3 md:flex-row max-lg:pb-4 default: items-center justify-center gap-2 md:gap-14 mt-4 max-lg:bg-white"
		>
			{#each companies as company (company.id)}
				<a href={company.url} target="_blank" rel="noopener noreferrer">
					<Media
						class="px-3 py-1"
						sourcesets={{
							"<2xl": [0, 200],
							">2xl": [0, 200],
						}}
						source={company.photo}
						width={160}
						height={160}
						alt={company.name[tenant.locale]}
					/>
				</a>
			{/each}
		</div>
	</div>
</section>
